import type { AppRouteModule } from '/@/router/types';

import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

const route: AppRouteModule = {
  /**
   * 'order-coordination': '订单协同',
   */
  path: '/order-coordination',
  name: 'OrderCoordination',
  component: LAYOUT,
  redirect: '/order-coordination/purchase-order-receive-process',
  meta: {
    icon: 'mingcute:certificate-line',
    title: t('routes.order-coordination.main'),
    orderNo: 10100,
    roles: [20222071],
  },
  children: [
    /**
     * '': 'dd01_采购订单接收处理',
     */
    {
      path: 'purchase-order-receive-process',
      name: 'PurchaseOrderReceiveProcess',
      component: () => import('/@/views/order-coordination/purchase-order-receive-process/index.vue'),
      meta: {
        title: t('routes.order-coordination.purchase-order-receive-process'),
        roles: [20222072],
      },
    },
    /**
     * 'purchase-order-delivery-process': 'dd02_采购订单发货处理',
     */
    {
      path: 'purchase-order-delivery-process',
      name: 'PurchaseOrderDeliveryProcess',
      component: () => import('/@/views/order-coordination/purchase-order-delivery-process/index.vue'),
      meta: {
        title: t('routes.order-coordination.purchase-order-delivery-process'),
        roles: [20222073],
      },
    },
    /**
     * 'receive-quality-storage-query': 'dd03_收货质检入库情况查询表',
     */
    {
      path: 'receive-quality-storage-query',
      name: 'ReceiveQualityStorageQuery',
      component: () => import('/@/views/order-coordination/receive-quality-storage-query/index.vue'),
      meta: {
        title: t('routes.order-coordination.receive-quality-storage-query'),
        roles: [20222074],
      },
    },
    /**
     * 'branch-billing-info': '分公司开票信息查询',
     */
    {
      path: 'branch-billing-info',
      name: 'BranchBillingInfo',
      component: () => import('/@/views/order-coordination/branch-billing-info/index.vue'),
      meta: {
        title: t('routes.order-coordination.branch-billing-info'),
        roles: [20222075],
      },
    },
    /**
     * 'branch-arrival-contacts': '分公司到货联系人查询',
     */
    {
      path: 'branch-arrival-contacts',
      name: 'BranchArrivalContacts',
      component: () => import('/@/views/order-coordination/branch-arrival-contacts/index.vue'),
      meta: {
        title: t('routes.order-coordination.branch-arrival-contacts'),
        roles: [20222076],
      },
    },
    /**
     * 'purchase-ship': '采购订单发货（松裕）',
     */
    {
      path: 'purchase-ship',
      name: 'PurchaseShip',
      component: () => import('/@/views/order-coordination/purchase-ship/index.vue'),
      meta: {
        title: t('routes.order-coordination.purchase-ship'),
        roles: [20223960],
      },
    },
    /**
     * 'purchase-query': '采购订单查询（松裕）',
     */
    {
      path: 'purchase-query',
      name: 'PurchaseQuery',
      component: () => import('/@/views/order-coordination/purchase-query/index.vue'),
      meta: {
        title: t('routes.order-coordination.purchase-query'),
        roles: [20223961],
      },
    },
    /**
     * 'sy-file-query': '分公司到货联系人查询',
     */
    {
      path: 'sy-file-query',
      name: 'SyFileQuery',
      component: () => import('/@/views/order-coordination/sy-file-query/index.vue'),
      meta: {
        title: t('routes.order-coordination.sy-file-query'),
        roles: [20223969],
      },
    },
    /**
     * 制版文件上传
     */
    {
      path: 'plate-roll-upload',
      name: 'PlateRollUpload',
      component: () => import('/@/views/order-coordination/plate-roll-upload/index.vue'),
      meta: {
        title: t('routes.order-coordination.plate-roll-upload'),
        roles: [20225707],
      },
    },
    /**
     * 制版信息录入
     */
    {
      path: 'plate-roll-info',
      name: 'PlateRollInfo',
      component: () => import('/@/views/order-coordination/plate-roll-info/index.vue'),
      meta: {
        title: t('routes.order-coordination.plate-roll-info'),
        roles: [20225708],
      },
    },
  ],
};

export default route;
